module.exports = __webpack_public_path__ + "static/media/img-destaque-home.fed1b0ab.jpg";